module.exports = __webpack_public_path__ + "img/51.77a59868.webp";